<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="breadcrumb-redesign-container">
          <ul v-if="arrayLength > 1" id="menu">
            <li @click="showRemainingList()">
              <span class="dots"></span>
              <span>></span>
            </li>
            <li
              v-for="(item, index) in breadcrumbData.slice(dataLength - 2, dataLength)"
              :key="item.NavigationTitle"
            >
              <a
                :href="index === 0 && item.Url"
                :class="[
                  index === 0 && item.NavigationTitle.length > 6 ? 'beforeLast' : '',
                  indexRange === index ? 'linkActive' : '',
                ]"
                @click="changeIndex(index)"
                >{{ item.NavigationTitle }}</a
              >
              <!-- NOSONAR -->
              <span v-if="index === 0">></span>
            </li>
          </ul>
          <ul v-if="arrayLength === 1" id="menu">
            <li v-for="(item, index) in breadcrumbData" :key="item.NavigationTitle">
              <a
                :href="index === 0 && item.Url"
                :class="[
                  index === 0 && item.NavigationTitle.length > 6 ? 'beforeLast' : '',
                  indexRange === index ? 'linkActive' : '',
                ]"
                @click="changeIndex(index)"
                >{{ item.NavigationTitle }}</a
              >
              <!-- NOSONAR -->
              <span v-if="index === 0">></span>
            </li>
          </ul>
          <ul :class="showRemainingBreadcrumb ? 'toggle-open' : ''" class="hidden-content">
            <li
              v-for="(item, index) in breadcrumbData.slice(0, dataLength - 2).reverse()"
              :key="item.NavigationTitle"
            >
              <!-- NOSONAR -->
              <a
                :href="item.Url"
                :class="indexRange === index ? 'linkActive' : ''"
                @click="changeIndex(index)"
                >{{ item.NavigationTitle }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-breadcrumb',
  props: {
    breadcrumbData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      arrayLength: this.breadcrumbData.length - 1,
      dataLength: this.breadcrumbData.length,
      showRemainingBreadcrumb: false,
      indexRange: -1,
    };
  },
  methods: {
    showRemainingList() {
      this.showRemainingBreadcrumb = !this.showRemainingBreadcrumb;
    },
    changeIndex(index) {
      this.indexRange = index;
    },
  },
};
</script>
